<template>
  <div class="settings-card">
    <div class="card-header">
      <h3><i class="fas fa-file-invoice-dollar"></i> Cấu hình Tài chính & Công nợ</h3>
    </div>
    <div class="card-body">
      <div class="settings-list">
        <div class="setting-item">
          <div class="setting-info">
            <label>Kích hoạt theo dõi công nợ</label>
            <p>Cho phép hệ thống ghi nhận và quản lý các khoản nợ của khách hàng/nhà cung cấp</p>
          </div>
          <van-switch v-model="localData.enableDebtTracking" @input="update" size="24px" />
        </div>

        <div class="form-group mb-4">
          <label>Tài khoản thu mặc định (Phải thu khách hàng)</label>
          <input type="text" v-model="localData.defaultReceivableAccount" @change="update" class="form-control" placeholder="Ví dụ: 131">
        </div>

        <div class="form-group mb-4">
          <label>Tài khoản chi mặc định (Phải trả NCC)</label>
          <input type="text" v-model="localData.defaultPayableAccount" @change="update" class="form-control" placeholder="Ví dụ: 331">
        </div>

        <div class="setting-item">
          <div class="setting-info">
            <label>Cho phép thanh toán từng phần</label>
            <p>Cho phép khách hàng trả trước một phần tiền, phần còn lại chuyển thành nợ</p>
          </div>
          <van-switch v-model="localData.allowPartialPayment" @input="update" size="24px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data() {
    return {
      localData: JSON.parse(JSON.stringify(this.data))
    }
  },
  watch: {
    data: {
      handler(val) {
        this.localData = JSON.parse(JSON.stringify(val));
      },
      deep: true
    }
  },
  methods: {
    update() {
      this.$emit('update', 'finance', this.localData);
    }
  }
}
</script>

